import React from 'react';
import { useSentryUser } from '../hooks/useSentryUser';

interface Props {
  children: React.ReactNode;
}

const SentryUserProvider: React.FC<Props> = ({ children }) => {
  useSentryUser();
  return <>{children}</>;
};

export default SentryUserProvider;
